// packages import
import { Box } from '@mui/material'
import { FC, useContext, useEffect, useState } from 'react'
// component block
import { EmptyData } from '../components/common/EmptyData'
// others
import { useDebounce } from 'use-debounce'
import { useFetchAllVendorsLazyQuery, Vendor } from '../../generated'
import { Alert } from '../components/common/Alert'
import { ContentHead } from '../components/common/ContentHead'
import VendorListing from '../components/vendors'
import VenderModal from '../components/vendors/VenderModal'
import { GRAPHQL_QUERY_POLICY, QUERY_PARAMS } from '../constants'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { CardBox } from '../theme/styleComponents'
import { flexCenter } from '../theme/styleConstants'
import { SearchWithKeypress } from '../components/common/SearchWithKeypress'
import VendorFilter from '../components/vendors/VendorFilter'
import { useSearchParams } from 'react-router-dom'

export const VendorContainer: FC = () => {
  const { searchValue, dispatch: reducerDispatch, currentPage, isOpen } = useContext(AppContext)
  const handleClose = () => reducerDispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })
  const [vendors, setVendors] = useState<Vendor[]>([])

  const [debouncedSearchValue] = useDebounce(searchValue, 500)
  const [searchParams] = useSearchParams()
  const orderBy = searchParams.get(QUERY_PARAMS.ORDER_BY)
  const orderDirection = searchParams.get(QUERY_PARAMS.ORDER_DIRECTION)

  const [fetchAllVendors, { loading, refetch }] = useFetchAllVendorsLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onError(error) {
      Alert.error(error.message)
    },
    onCompleted(data) {
      const { fetchAllVendors } = data || {}
      const { pagination, vendors, response } = fetchAllVendors || {}
      const { status } = response || {}
      if (status === 200) {
        setVendors(vendors as Vendor[])

        if (pagination) {
          const { totalPages, totalCount } = pagination
          totalPages && reducerDispatch({ type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: totalPages })
          totalCount && reducerDispatch({ type: ActionType.SET_TOTAL_DATA_COUNT, totalDataCount: totalCount })
        }
      }
    }
  })
  useEffect(() => {
    return () => {
      reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
      reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    fetchAllVendors({
      variables: {
        fetchVendorsInput: {
          keyword: debouncedSearchValue,
          orderBy,
          orderDirection,
          withDeleted: true,
          paginationOptions: {
            limit: 20,
            page: currentPage
          }
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, debouncedSearchValue, orderBy, orderDirection])

  const isEmpty = !loading && !vendors.length

  return (
    <>
      <CardBox marginTop={3}>
        <ContentHead title={'Vendors'} buttonText={'Add Vendor'} />

        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} m={2}>
          <SearchWithKeypress searchPlaceholder={'Search'} />
          <VendorFilter />
        </Box>

        {isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 265px)' }}>
            <EmptyData title={'No Vendors found'} />
          </Box>
        ) : (
          <VendorListing vendors={vendors} refetch={refetch} loading={loading} />
        )}
      </CardBox>

      <VenderModal isOpen={isOpen} handleClose={handleClose} refetch={refetch} />
    </>
  )
}
